import { useEffect, useState } from 'react';
import auth from 'works/legacy/lib/auth';

const SECOND_IN_MILLISECONDS = 1000;
const TWO_MINUTES_IN_MILLISECONDS = 120 * SECOND_IN_MILLISECONDS;

export function useExpirationClock(expiresInSeconds?: number) {
  const [isExpired, setIsExpired] = useState(false);
  const [isAboutToExpire, setIsAboutToExpire] = useState(false);
  const [timeToExpire, setTimeToExpire] = useState(0);

  useEffect(() => {
    if (!expiresInSeconds) return;

    const intervalId = setInterval(() => {
      const expirationTime =
        auth.lastRequestTime() + expiresInSeconds * SECOND_IN_MILLISECONDS;

      const expirationDiff = expirationTime - Date.now();
      const expired = expirationDiff <= 0;

      setIsExpired(expired);
      setIsAboutToExpire(expirationDiff <= TWO_MINUTES_IN_MILLISECONDS);
      setTimeToExpire(expired ? 0 : expirationDiff);
    }, SECOND_IN_MILLISECONDS);

    return () => clearInterval(intervalId);
  }, [expiresInSeconds]);

  return { isExpired, isAboutToExpire, timeToExpire };
}
